// extracted by mini-css-extract-plugin
export default {"wrapper":"search_page_wrapper__MGt6u","left":"search_page_left__GaDje","right":"search_page_right__EuQWO"};